<div class="document-bulk-container">

  <form [formGroup]="documentFormGroup">
    <div class="ui-g ui-fluid ">
      <div class="ui-g-6 ui-md-6 ui-lg-6">
        <div class="label-block">
          <form-factory [formGroup]="documentFormGroup" [model]="documentNotes"></form-factory>
        </div>
      </div>
    </div>
    <div class="ui-g ui-fluid">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <app-button text="CONTINUE TO VALIDATION" (onClick)="validateToShowDocumentGrid()"></app-button>
      </div>
    </div>
  </form>
  <ng-container *ngIf="isDocumentGrid">
  <div class="ui-g ui-fluid" *ngIf="isShowValidateDocumentGridData">
    <div class="ui-g-12 ui-md-12 ui-lg-12">
      <app-basic-grid [configuration]="documentServerGridConfiguration"
                      [data]="data">
      </app-basic-grid>
    </div>
    <div class="ui-g ui-fluid"><app-button (onClick)="finalBulkUpdate()" text="FINISH BULK UPDATE" [disabled]="isFinalBulkUpdate"></app-button></div>
  </div>
  </ng-container>
</div>
